<template>
  <div class="tabs" role="tablist">
    <button
      v-for="opt in options"
      :key="opt.value"
      class="tabs__tab"
      :class="{ active: modelValue === opt.value }"
      role="tab"
      :aria-selected="modelValue === opt.value"
      :aria-label="opt.label"
      :title="opt.label"
      @click="$emit('update:modelValue', opt.value)"
    >
      <span class="tabs__emoji">{{ opt.emoji }}</span><span class="tabs__label">{{ opt.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SortTabs',
  props: {
    modelValue: { type: String, required: true },
    options: { type: Array, required: true }, // [{ value, label, emoji }]
  },
  emits: ['update:modelValue'],
}
</script>

<style scoped>
.tabs {
  display: inline-flex;
  gap: 4px;
  padding: 5px;
  background: var(--cream);
  border: var(--border-w) solid var(--border-c);
  border-radius: var(--r-pill);
  box-shadow: var(--shadow-sm);
  flex-wrap: wrap;
  justify-content: center;
}
.tabs__tab {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 0.92rem;
  padding: 8px 18px;
  border: none;
  background: transparent;
  color: var(--ink-700);
  border-radius: var(--r-pill);
  cursor: pointer;
  transition: all 0.2s var(--ease-out);
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.tabs__emoji { font-size: 0.95rem; }
.tabs__tab:hover { background: var(--banana-100); }
.tabs__tab.active {
  background: var(--choco);
  color: var(--banana-400);
  transform: translateY(-1px);
}

/* On narrow screens, show ICONS ONLY so every tab fits on one line with no
   horizontal scroll (which was hiding the first tab). The label still shows
   in the intro panel below once a tab is selected, and stays accessible via
   aria-label/title. */
@media (max-width: 560px) {
  .tabs {
    flex-wrap: nowrap;
    max-width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .tabs__tab {
    flex: 1 1 0;
    justify-content: center;
    padding: 10px 8px;
    gap: 0;
  }
  .tabs__label { display: none; }
  .tabs__emoji { font-size: 1.25rem; }
}
</style>
